import { render, staticRenderFns } from "./editnotice.vue?vue&type=template&id=3e3f9374"
import script from "./editnotice.vue?vue&type=script&lang=js"
export * from "./editnotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports